



























import Vue from 'vue';
import { mapState } from 'vuex';

import { KPortalHeader, KAppToolbar, KNoticeContainer } from '@kasasa/fbase-components';

export default Vue.extend({
	name: 'App',

	components: {
		KPortalHeader, KAppToolbar, KNoticeContainer
	},

	computed: {
		...mapState(['auth'])
	},
});
